// Module
var code = "<a class=\"product-action btn btn--large btn--primary\" href=\"javascript:;\" ng-href=\"{{whereToBuyUrl() | toOneDomain }}\"> <span class=\"product-action--where\" system-dictionary=\"WhereToBuy\"> </span> </a>";
// Exports
module.exports = code;